import { render } from "./ChatsPage.vue?vue&type=template&id=16bc26ec"
import script from "./ChatsPage.vue?vue&type=script&lang=js"
export * from "./ChatsPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__